import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import {Publishers} from "./pages/Publishers";
import {App} from "./App";
import {Home} from "./pages/Home";
import {About} from "./pages/About";
import {Podcasts} from "./pages/Podcasts";
import {Careers} from "./pages/Careers";
import {Work} from "./pages/Work";
import { Blog } from './pages/Blog';
import { SelfServe } from './pages/SelfServe';
import i18n from "i18next"
import {initReactI18next} from "react-i18next";
import en from "./locales/en.json"

// i18next init
i18n.use(initReactI18next).init({
    resources: {en},
    fallbackLng: "en",
    ns: 'self',
    interpolation: {
        escapeValue: false
    }
})

const router = createBrowserRouter([
    {path: "/sizzl", element: <SelfServe/>},
    {path: "/sizzl/tellUs", element: <SelfServe tellUs={true}/>},
    {path: "/sizzl/:create", element: <SelfServe/>},
    {path: "/", element: <App/>, children: [
        {path: "/", element: <Home/>},
        {path: "/publishers", element: <Publishers/>},
        {path: "/about", element: <About/>},
        {path: "/podcasts", element: <Podcasts/>},
        {path: "/blog", element: <Blog/>},
        {path: "/careers", element: <Careers/>},
        {path: "/work", element: <Work/>},
        {path: "/*", element: <Home/>},
    ]}
])

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
      <RouterProvider router={router} />
  </React.StrictMode>
);
